import { withPrefix } from 'gatsby';
import React from 'react'
import { Graphic } from '../../../../svg/graphic';
import { Relation } from '../../../../svg/relation';
import s from './puedo-saber-como-esta-invertido-mi-dinero.module.css'

const PuedoSaberComoEstaInvertidoMiDinero = () => {
  return (
    <div className={'containerWrap'}>
      <h2 className="tw-mt-0 tw-mb-12 tw-mb-12@lg center w-80 w-auto@lg ml-auto mr-auto tw-pt-2 tw-pt-4@lg font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-24@lg">
        ¿Puedo saber cómo está invertido mi dinero?
      </h2>

      <div className={`flex direction-column direction-row@lg justify-center`}>
        <div className={`w-100 w-40@lg order-2 order-1@lg`}>
          <img
            src={withPrefix('/images/teleoperator.svg')}
            alt="teleoperator"
            className={`${s.imagenBox4} ${s.displayDesktopIcon}`}
          />
        </div>

        <div className={`w-100 w-60@lg order-1 order-2@lg`}>
          <div className={`flex tw-mb-0 tw-mb-4@lg ${s.message}`}>
            <div className={`brad-4 font-family-primary c-gray--4 fw-4 tw-f-14 tw-f-16@lg tw-p-4 tw-p-8@lg center left@lg bg-white ${s.triangle}`}>
              Si quieres conocer en detalle cómo está invertido tu dinero, ingresa a la sección “Mis Inversiones” en tu <span className='b'>Agencia Virtual</span> donde podrás ver detalladamente.
            </div>
          </div>

          <div className={`w-50 w-40@lg ${s.displayMobileIcon}`}>
            <img
              src={withPrefix('/images/teleoperator.svg')}
              alt="teleoperator"
              className={`${s.imagenBox4}`}
            />
          </div>

          <div
            className={`flex direction-column items-center justify-center tw-p-6 tw-p-8@lg tw-mb-6 tw-mb-4@lg  border brad-4 bg-white ${s.messageList}`}
          >
            <div className="flex items-start mr-auto tw-mb-2">
              <div className="tw-mr-2">
                <Graphic fill={'#04A6A2'} width={'16'} height={'16'} />
              </div>
              <div className="flex items-center font-family-primary c-gray--4 fw-4 tw-f-14 tw-f-16@lg">
                <span>
                  La composición de tu fondo en instrumentos de renta
                  variable y renta fija.
                </span>
              </div>
            </div>

            <div className="flex items-start mr-auto tw-mb-2">
              <div className="tw-mr-2">
                <img
                  src={withPrefix('/images/country.svg')}
                  alt="country"
                  height={16}
                />
              </div>
              <div className="flex items-center font-family-primary c-gray--4 fw-4 tw-f-14 tw-f-16@lg">
                <span>
                  Los países y sectores económicos en los que está invertido
                  tu fondo.
                </span>
              </div>
            </div>

            <div className="flex items-start mr-auto tw-mb-2">
              <div className="tw-mr-2">
                <Relation fill={'#04A6A2'} width={'16'} height={'16'} />
              </div>
              <div className="flex items-center font-family-primary c-gray--4 fw-4 tw-f-14 tw-f-16@lg">
                <span>
                  La relación de acciones, bonos, fondos de inversión y
                  fondos mutuos en la que tenemos invertido tu fondo.
                </span>
              </div>
            </div>

            <div className="flex items-start mr-auto tw-mb-2">
              <div className="tw-mr-2">
                <img
                  src={withPrefix('/images/soles.svg')}
                  alt="soles"
                  height={18}
                />
              </div>
              <div className="flex items-center font-family-primary c-gray--4 fw-4 tw-f-14 tw-f-16@lg">
                <span>
                  La información financiera detallada de las empresas donde
                  está invertido tu fondo.
                </span>
              </div>
            </div>

            <div className="flex items-start mr-auto tw-mb-2">
              <div className="tw-mr-2">
                <img
                  src={withPrefix('/images/chronometer.svg')}
                  alt="chronometer"
                  height={28}
                />
              </div>
              <div className="flex items-center font-family-primary c-gray--4 fw-4 tw-f-14 tw-f-16@lg">
                <span>
                  La evolución del valor cuota del tipo fondo en el que se
                  encuentra tu fondo de pensión y tus aportes voluntarios,
                  en caso los tuvieras.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default PuedoSaberComoEstaInvertidoMiDinero;
